import type { OrthoFormParams } from '@witmetrics/unison-core';
import type { OrthoParameterKey } from '@witmetrics/utils';
import { ORTHO_PARAMETERS } from '@witmetrics/utils/constants';
import ServiceParameter from '@/components/ServiceParameter';
import TabsBlock, { Tab } from '@/components/TabsBlock';
import EngravementForm from '../EngravementForm';
import type { OrthoFormSection } from './types';
import { classes } from '../utils';
import { applyOrthoSideEffects } from './utils';

export type OrthoFormProps = {
  params: OrthoFormParams;
  onChange: (params: OrthoFormParams) => void;
};

export default function OrthoForm({ params, onChange }: OrthoFormProps) {
  const renderParam = (key: OrthoParameterKey) => (
    <ServiceParameter
      parameter={ORTHO_PARAMETERS[key]}
      value={params[key]}
      onChange={(update) => onChange(applyOrthoSideEffects(params, update))}
    />
  );

  return (
    <TabsBlock<OrthoFormSection[]>
      className={classes.tabsBlock}
      bodyClassName={classes.tabsBody}
      orientation="vertical"
      name="ortho-parameters"
      defaultTab="QUICK_SETUP">
      <Tab className={classes.tab} name="QUICK_SETUP" label="Quick Setup">
        {renderParam('baseType')}
        {renderParam('infill')}
        {renderParam('baseHeight')}
      </Tab>
      <Tab className={classes.tab} name="ENGRAVEMENT" label="Engravement">
        <EngravementForm
          engravedText={params.engravedText}
          onChange={(engravedText) => onChange({ ...params, engravedText })}
        />
        {renderParam('engraveMethod')}
      </Tab>
      <Tab className={classes.tab} name="BASING" label="Basing">
        {renderParam('baseType')}
        {renderParam('infill')}
        {renderParam('gingivaMargin')}
        {renderParam('baseHeight')}
        {renderParam('baseChamfer')}
        {renderParam('baseChamferHeight')}
        {renderParam('drainageHoles')}
        {renderParam('baseWallThickness')}
        {renderParam('baseReinforcementType')}
        {renderParam('partials')}
      </Tab>
      <Tab className={classes.tab} name="ATTACHMENT" label="Attachment">
        {renderParam('attachmentType')}
        {renderParam('articulatorType')}
      </Tab>
      <Tab className={classes.tab} name="PINS" label="Pins">
        {renderParam('occlusionPins')}
      </Tab>
      <Tab className={classes.tab} name="WAXING" label="Waxing">
        {renderParam('waxing')}
      </Tab>
      {/*<Tab className={classes.tab} name="TRIMLINE" label="Trimline">*/}
      {/*  <TrimlineForm params={params} onChange={onChange} />*/}
      {/*</Tab>*/}
      <Tab className={classes.tab} name="OTHER" label="Other">
        {renderParam('biteCorrection')}
        {params.biteCorrection !== 'no_correction' &&
          renderParam('maxBitePenetration')}
        {renderParam('attachmentRemoval')}
        {renderParam('impressionCleaning')}
        {params.impressionCleaning !== 'no_impression_cleaning' &&
          renderParam('artifactThreshold')}
        {renderParam('lingualGingivaCrop')}
      </Tab>
      <Tab className={classes.tab} name="ADVANCED" label="Advanced">
        {renderParam('orientation')}
        {renderParam('parallelizeBases')}
      </Tab>
    </TabsBlock>
  );
}
